import React from 'react';
import { prop } from 'ramda';
import { Button } from 'js/components/common/Button';
import { useUserSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import { Logo } from '../Logo';
import { Inbox } from '../Inbox';
import * as hooks from 'js/components/main/DefaultHeader/hooks';
import { MyAccount } from '../MyAccount';
import { MyBalance } from '../MyBalance';
import style from './DesktopHeader.scss';
import { MyBonuses } from '../MyBonuses';

export const DesktopHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return (
        <div className={`${style.header} ${!isLoggedIn && style.userHeader}`}>
            <div className={style.info}>
                <Logo />
            </div>
            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            <MyBonuses/>
                            <Inbox />
                            <MyAccount />
                            <MyBalance />
                        </>
                    )
                    : (
                        <>
                            <Button
                                size="small"
                                color="success"
                                view="secondary"
                                className={`${style.login} btn_action_login`}
                                onClick={onLoginButtonClick}
                            >
                                <span className="shine-animation"></span>
                                {translate('login.button.loginHeader')}
                            </Button>
                        </>
                    )
                }
            </div>
        </div>
    );
};
